// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import authService from '../services/auth-service';
import Message from './shared/Message';
import Wrapper from './shared/FormFieldWrapper';
import Button from './shared/Button';
import TextInput from './shared/TextInput';

type State = {
  loading: boolean,
  showForm: boolean,
  error: string,
  message: string,
  email: string
}

type Props = {
  email?: string
} & WithTranslation;

class ChangePassword extends Component<Props, State> {
  props: Props;

  state: State = {
    loading: false,
    showForm: true,
    error: '',
    message: '',
    email: this.props.email || '',
    isComplete: false
  };

  componentWillReceiveProps({ email }: Props) {
    this.setState({ email });
  }

  onSubmit = (evt: Event) => {
    evt.preventDefault();
    this.setState({ loading: true });
    const email = this.state.email;
    const { t } = this.props;
    authService.resetPassword(email).then(() => {
      this.setState({
        loading: false,
        error: '',
        showForm: false,
        message: t('message'),
        isComplete: true
      });
    }).catch(() => {
      this.setState({
        loading: false,
        message: '',
        error: t('error')
      });
    });
  }
  onChange = (evt: SyntheticInputEvent) => {
    this.setState({ email: evt.target.value });
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        {this.state.showForm && !this.props.email &&
          <form onSubmit={this.onSubmit}>
            <TextInput
              value={this.state.email}
              onChange={this.onChange}
              type='email'
              name='email'
              required
              label={t('email')}
            />
            <Button
              onClick={this.onSubmit}
              className='btn is-primary'
              label={t('reset')}
              isLoading={this.state.loading}
            />
          </form>
        }
        <div className='form'>
          {this.state.message ?
            <Wrapper>
              <Message className='is-success'>{this.state.message}</Message>
            </Wrapper>
            : ''}

          {this.state.error ?
            <Wrapper>
              <Message className='is-error'>{this.state.error}</Message>
            </Wrapper>
            : ''}
        </div>
        {this.props.email &&
          <div>
            <Button
              formSubmit
              type='submit'
              className={`is-primary ${this.state.isComplete ? 'is-success' : ''}`}
              onClick={this.onSubmit}
              label={this.state.isComplete ? t('sent') : t('reset')}
              isLoading={this.state.loading}
              isComplete={this.state.isComplete}
            />
          </div>
        }
      </div>
    );
  }
}

export default withTranslation('changePassword')(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/change-password.js